import React from 'react';
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  intro?: string;
}
export function PageHeader({
  eyebrow,
  title,
  intro
}: PageHeaderProps) {
  return <section className="bg-navy pb-14 pt-32 lg:pb-16 lg:pt-40" data-id="element-146" data-mp="3cjpfi57guwww">
      <div className="mx-auto max-w-shell px-6 lg:px-8" data-id="element-147" data-mp="3re3t1q89he46">
        <div className="flex items-center gap-4" data-id="element-148" data-mp="3mezlf40zjofy">
          <span className="h-px w-10 bg-gold" data-id="element-149" data-mp="3mgamgw31qi3d" />
          <span className="text-[11px] font-semibold uppercase tracking-overline text-gold-light" data-id="element-150" data-mp="2ypezcc9jcb2g">
            {eyebrow}
          </span>
        </div>
        <h1 className="mt-5 max-w-3xl font-serif text-3xl leading-tight text-white sm:text-4xl lg:text-[2.75rem]" data-id="element-151" data-mp="2tsojnq1n7hhk">
          {title}
        </h1>
        {intro && <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300" data-id="element-152" data-mp="33o00cdwm2yry">
            {intro}
          </p>}
      </div>
    </section>;
}